import { RudderAnalytics } from '@rudderstack/analytics-js'

// Allow RUDDERSTACK env var on window for TypeScript
declare global {
  interface Window {
    RUDDERSTACK_ANALYTICS_KEY: string | undefined
    RUDDERSTACK_ANALYTICS_URL: string | undefined
  }
}

let rudderAnalytics: RudderAnalytics | null = null
let lastPageUrl: string | null = null

function getRudderAnalytics(): RudderAnalytics | null {
  return rudderAnalytics
}

function trackPageView({
  isClientSideNavigation,
}: {
  isClientSideNavigation: boolean
}) {
  const pageUrl = new URL(window.location.href)
  pageUrl.hash = ''
  const url = pageUrl.toString()
  const referrer = isClientSideNavigation
    ? (lastPageUrl ?? document.referrer)
    : document.referrer

  rudderAnalytics?.page({
    is_client_side_navigation: isClientSideNavigation,
    path: window.location.pathname,
    referrer,
    referring_domain: referrer ? new URL(referrer).host : '',
    search: window.location.search,
    // Client-side titles stay stale until the Vike head metadata issue is fixed.
    title: document.title,
    url,
  })
  lastPageUrl = url
}

function loadRudderstack() {
  if (rudderAnalytics) return
  if (window.RUDDERSTACK_ANALYTICS_KEY && window.RUDDERSTACK_ANALYTICS_URL) {
    rudderAnalytics = new RudderAnalytics()
    rudderAnalytics.load(
      window.RUDDERSTACK_ANALYTICS_KEY,
      new URL(
        window.RUDDERSTACK_ANALYTICS_URL,
        window.location.toString()
      ).toString(),
      {
        anonymousIdOptions: {
          autoCapture: { enabled: true, source: 'segment' },
        },
        pluginsSDKBaseURL: 'https://assets.slite.com/rsa',
      }
    )
    trackPageView({ isClientSideNavigation: false })
  }
}

export { getRudderAnalytics, loadRudderstack, trackPageView }
